import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_CAROUSEL_MEMBERSHIP_CONFIGURATION = createFcmDetails('carousel_membership_configuration', {
	owner: 'TBD',
	context: 'Petition discover page (carousel)',
	description: `Defines whether there should be a membership interstitial card and its configuration.

		If "contribute_url" is set, it will override a default url targeting the default membership page (useful for 3rd-party pages).
	`,
	template: {
		amount_base_units: 300,
		contribute_url: undefined,
	},
	import: false,
});
